"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var DataHooks_1 = require("../DataHooks");
var Grid_st_css_1 = require("../Grid.st.css");
var constants_1 = require("../constants");
var Item = /** @class */ (function (_super) {
    __extends(Item, _super);
    function Item() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Item.prototype.getItemDataAttributes = function (_a) {
        var _b;
        var rowSpan = _a.rowSpan, colSpan = _a.colSpan;
        return _b = {},
            _b[DataHooks_1.GridDataKeys.rowSpan] = rowSpan,
            _b[DataHooks_1.GridDataKeys.columnSpan] = colSpan,
            _b;
    };
    Item.prototype.render = function () {
        var _a = this.props, children = _a.children, rowSpan = _a.rowSpan, colSpan = _a.colSpan;
        return (React.createElement("li", __assign({ "data-hook": DataHooks_1.GridDataHooks.item, className: Grid_st_css_1.default.item, style: {
                gridColumnEnd: "span " + colSpan,
                gridRowEnd: "span " + rowSpan,
            } }, this.getItemDataAttributes({
            rowSpan: rowSpan,
            colSpan: colSpan,
        })), children));
    };
    Item.displayName = 'Item';
    Item.defaultProps = {
        colSpan: constants_1.DEFAULT_COLUMN_SPAN,
        rowSpan: constants_1.DEFAULT_ROW_SPAN,
    };
    return Item;
}(React.PureComponent));
exports.Item = Item;
//# sourceMappingURL=Item.js.map